<template>
    <div>
        <div class="login-container d-flex justify-content-center align-items-center">
            <div>
                <div class="logo mb-4">
                    <img src="@/assets/images/SE_Logo_White_RGB.png" alt="Logo Siemens" class="mx-auto d-block">
                </div>
                <div class="login-form position-relative">
                    <h3 class="login-head position-absolute top mt-4">修改密码</h3>
                    <b-form :model="changePasswordForm">
                        <b-form-group
                            id="oldPassword"
                            label="原密码"
                            class="mt-3"
                            label-for="input-1"
                        >
                            <b-form-input
                                id="input-1"
                                class="mt-1"
                                type="password"
                                v-model="changePasswordForm.oldPassword"
                                required
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-2" label="新密码:" label-for="input-2"
                                      class="mt-3 position-relative">
                            <b-form-input
                                id="newPassword"
                                class="mt-1"
                                v-model="changePasswordForm.newPassword"
                                type="password"
                                @input="onInputNewPassword()"
                                required
                            ></b-form-input>
                            <b-form-text id="password-help-block">
                                新密码必须大于12位并包含大小写字母与数字
                            </b-form-text>
                            <div id="pwdStrength" class="position-absolute pwd-strength"></div>
                        </b-form-group>
                        <b-form-group id="input-group-2" label="重复输入新密码:" label-for="input-2" class="mt-3">
                            <b-form-input
                                id="confirmNewPassword"
                                class="mt-1"
                                v-model="changePasswordForm.confirmNewPassword"
                                type="password"
                                required
                            ></b-form-input>
                        </b-form-group>
                        <span v-if="showErrorMsg" class="text-danger">{{ errorMsg }}</span>
                        <b-button @click="onSubmit" type="submit" size="md" pill block
                                  class="mt-3 mb-5"
                                  style="font-size: 14px"
                                  variant="primary">
                            保存修改
                        </b-button>
                    </b-form>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import emLoginMixin from "@/mixin/em/common/stuffs/login/emLoginMixin";

export default {
    name: "emChangePassword",
    mixins: [emLoginMixin],
    data() {
        return {
            changePasswordForm: {
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: ''
            },
            loading: false,
            errorMsg: '',
            showErrorMsg: false
        }
    },
    methods: {
        onSubmit(event) {
            event.preventDefault();
            this.$store.dispatch("api/post", {
                url: this.$store.state.emAclUser.baseModuleUrl + "/sso/changePassword",
                data: this.changePasswordForm,
            }).then((response) => {
                const data = response.data
                if (data) {
                    if (data.code !== 200) {
                        this.showErrorMsg = true;
                        this.errorMsg = data.message
                    } else {
                        this.showErrorMsg = false;
                        this.redirectToLogin()
                    }
                }
            })
        },
        onInputNewPassword() {
            let strengthText = '';
            const newPassword = this.changePasswordForm.newPassword
            if (newPassword) {
                const passwordStrength = this.$zxcvbn(newPassword)
                switch (passwordStrength.score) {
                    case 0:
                        strengthText = "太弱";
                        break;
                    case 1:
                        strengthText = "弱";
                        break;
                    case 2:
                        strengthText = "一般";
                        break;
                    case 3:
                        strengthText = "良好";
                        break;
                    case 4:
                        strengthText = "极佳";
                        break;
                }
            }
            let el = document.getElementById("pwdStrength");
            el.innerText = strengthText;
            el.style.display = strengthText === '' ? 'none' : 'inline';
        }
    }
}
</script>

<style scoped>
.login-container {
    height: 100vh;
    background-image: linear-gradient(#8A00E5 50%, #e3e3e3 50%);
}

.login-form {
    padding: 80px 30px 10px;
    z-index: 1;
    background-color: white;
    min-width: 350px;
    min-height: 390px;
    font-weight: 700;
    font-size: 14px;
}

.login-head {
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
    font-size: 24px;
}

.logo {
    width: 380px;
    height: 150px;
    overflow: hidden;
}

.logo img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
}

.pwd-strength {
    right: 0.3rem;
    bottom: 1.5rem;
    font-weight: bold;
    background-color: #dedede;
    border-radius: 20%;
    color: black;
    padding: 0.1rem;
    display: none;
}
</style>

